module.exports = __webpack_public_path__ + "img/logo-inmetrics-footer.2e158bd0.png";